export default class PopupsController {
    constructor() {
        this.$triggers = document.querySelectorAll('[data-popup-trigger]');
        this.$popups = document.querySelectorAll('[data-popup]');
        this.$popupCloseButtons = document.querySelectorAll('[data-popup-close]');

        this.init();
    }

    init() {
        this.$triggers.forEach(($trigger) => {
            $trigger.addEventListener('click', () => {
                const popupId = $trigger.dataset.popupTrigger;
                const $popup = Array.from(this.$popups).find(($popup) => $popup.dataset.popup === popupId);

                if (!$popup) {
                    throw new Error(`Popups Controller: Popup with id ${popupId} is not defined.`);
                }

                if ($popup.classList.contains('-show')) {
                    $popup.classList.remove('-show');
                } else {
                    this.$popups.forEach(($popup) => $popup.classList.remove('-show'));
                    $popup.classList.add('-show');
                }
            });
        });

        this.$popupCloseButtons.forEach(($closeButton) => {
            $closeButton.addEventListener('click', () => {
                const $popup = $closeButton.closest('[data-popup]');
                $popup.classList.remove('-show');
            });
        });

        document.addEventListener('click', (e) => {
            if (!e.target.closest('[data-popup]') && !e.target.closest('[data-popup-trigger]')) {
                this.$popups.forEach(($popup) => $popup.classList.remove('-show'));
            }
        });
    }
}